import React from "react";
import Icondigital from "../../icons/icon-digital.svg";
import Imagedigital from "../../images/icon-digital.svg";
import IconDataEngineering from "../../icons/icon-data-engineering.svg";
import IconOmnichannelPlatforms from "../../icons/icon-omnichannel-platforms.svg";
import IconDataVisualization from "../../icons/icon-data-visualization.svg";
import IconPersonalizationEngines from "../../icons/icon-personalization-engines.svg";
import IconIotService from "../../icons/icon-iot-service.svg";
import IconVoiceAnalytics from "../../icons/icon-voice-analytics.svg";
import PageBannerImage from "../../images/page-banner-data-analytics.png";
import IconDeliverPersonalized from "../../icons/icon-deliver-personalized.svg";
import IconRevenueOpportunities from "../../icons/icon-revenue-opportunities.svg";
import IconCustomerInteraction from "../../icons/icon-customer-interaction.svg";
import IconMaintenance from "../../icons/icon-maintenance.svg";
import ImageMaintenance from "../../images/icon-maintenance.svg";
import IconAwsColor from "../../icons/icon-aws-color.svg";
import IconAzureColor from "../../icons/icon-azure-color.svg";
import IconGcpColor from "../../icons/icon-gcp-color.svg";
import ImageUserBlank from "../../images/user-profile.png";
import ImageUserJustin from "../../images/justin-profile.jpg";
import IconYodish from "../../images/icon-yodish.png";
import IconTresata from "../../images/icon-tresata.svg";
import IconCB from "../../images/icon-CB.svg";
import ProductDataBannerImage from "../../images/page-banner-flexprint.png";
import { Link } from "gatsby";
import IconMLlib from "../../icons/icon-MLlib.svg";
import IconJupyter from "../../icons/icon-jupyter.svg";
import IconAnaconda from "../../icons/icon-Anaconda-DA.svg";
import IconPython from "../../icons/icon-Python.svg";
import IconTensorFlow from "../../icons/icon-TensorFlow.svg";
import IconKibana from "../../icons/icon-Kibana.svg";
import IconPowerBI from "../../icons/icon-Power-BI.svg";
import IconDeckGL from "../../icons/icon-Deck-GL.svg";
import IconGraph from "../../icons/icon-Graph.svg";
import IconReactJS from "../../icons/icon-React-JS.svg";
import IconD3 from "../../icons/icon-D3.svg";
import IconGeo from "../../icons/icon-geo.svg";
import IconHive from "../../icons/icon-Hive.svg";
import IconAthena from "../../icons/icon-Athena.svg";
import IconCassandra from "../../icons/icon-Cassandra.svg";
import IconNoSQL from "../../icons/icon-No-SQL.svg";
import IconOracle from "../../icons/icon-Oracle.svg";
import IconKafka from "../../icons/icon-Kafka.svg";
import IconSQL from "../../icons/icon-SQL.svg";
import IconRedshift from "../../icons/icon-Redshift.svg";
import IconHadoop from "../../icons/icon-Hadoop.svg";
import IconSplunk from "../../icons/icon-Splunk.svg";
import IconElasticsearch from "../../icons/icon-Elasticsearch.svg";
import IconSnowFlake from "../../icons/icon-snowflake.svg";
import IconBuildNextGen from "../../icons/icon-build-next-gen.svg";
import IconDeliverIntelligence from "../../icons/icon-deliver-intelligence.svg";
import IconImproveProcesses from "../../icons/icon-increase-efficiencies-m.svg";
import IconOracleColor from "../../icons/icon-oracle-color.svg";

import ImageFlexprint from "../../images/services-cs-flexprint.png";
import ImageSalesmateHalf from "../../images/service-cs-salesmate-half.jpg";
import ImageHtHalf from "../../images/service-cs-ht-half.jpg";

export const technologySliderObj = {
  ai: [
    {
      icon: <IconMLlib />,
      title: "MLlib"
    }, {
      icon: <IconJupyter />,
      title: "Jupyter"
    }, {
      icon: <IconAnaconda />,
      title: "Anaconda"
    }, {
      icon: <IconPython />,
      title: "Python"
    }, {
      icon: <IconTensorFlow />,
      title: "TensorFlow"
    },
  ],
  visualization: [
    {
      icon: <IconKibana />,
      title: "Kibana"
    }, {
      icon: <IconPowerBI />,
      title: "Power BI"
    }, {
      icon: <IconDeckGL />,
      title: "Deck.GL"
    }, {
      icon: <IconGraph />,
      title: "Graph"
    }, {
      icon: <IconReactJS />,
      title: "React.Js"
    }, {
      icon: <IconD3 />,
      title: "D3"
    }, {
      icon: <IconGeo />,
      title: "Geo"
    },
  ],
  analytics: [
    {
      icon: <IconHive />,
      title: "Hive"
    }, {
      icon: <IconAthena />,
      title: "Athena"
    }, {
      icon: <IconCassandra />,
      title: "Cassandra"
    }, {
      icon: <IconNoSQL />,
      title: "No SQL"
    }, {
      icon: <IconOracle />,
      title: "Oracle"
    }, {
      icon: <IconMLlib />,
      title: "Spark"
    }, {
      icon: <IconKafka />,
      title: "Kafka"
    }, {
      icon: <IconSQL />,
      title: "SQL"
    }, {
      icon: <IconRedshift />,
      title: "RedShift"
    }, {
      icon: <IconHadoop />,
      title: "Hadoop"
    }, {
      icon: <IconSplunk />,
      title: "Splunk"
    }, {
      icon: <IconElasticsearch />,
      title: "Elasticsearch"
    },
    {
      icon: <IconSnowFlake />,
      title: "Snowflake"
    },
  ]
};

export const technologySliderPlatforms = [
  {
    icon: <IconAwsColor />,
    title: "AWS"
  }, {
    icon: <IconGcpColor />,
    title: "GCP"
  }, {
    icon: <IconAzureColor />,
    title: "Azure"
  }, {
    icon: <IconOracleColor />,
    title: "Oracle"
  }
];

export const mainBannerObj = {
  classes: "",
  title: "data analytics & machine learning",
  header: (<>Data Analytics & <br /> Machine Learning</>),
  content: (<>Reshape your products, people, and competitive advantage using data analytics, AI, and ML.</>),
  mediaSource: PageBannerImage,
  mediaClass: "align-end",
  mediaType: "image"
};
export const pageIntroObj = {
  classes: "section-gap",
  title: "UNLEASH THE POWER OF YOUR DATA",
  header: (<>Use analytics and machine learning to unlock new growth and product opportunities</>),
  content: (<><p>According to the World Economic Forum report, 463 exabytes (1,048,576 terabytes) of data will be created each day globally by 2025. Data and AI/ML have sparked a new revolution that disrupts every business in every industry.</p>

    <p>The massive volume of data combined with cutting-edge and open source technologies in data analytics, parallel computing, and machine learning present companies with unique opportunities to reimagine their business models, deliver personalized experiences, automate processes, and reduce costs.</p>

    <p>Our data engineers and scientists have helped global brands discover, build and monetize data-driven business opportunities. We help our clients build analytics products, platforms, and solutions that deliver actionable intelligence at a massive scale from data preparation, transformation, integration to data science and interactive visualizations.</p> </>)
};
export const introColumnObj = {
  classes: "section-gap service-inner-intro",
  header: "our analytics expertise",
  subHeader: "Monetize your growing data with our advanced analytics, and AI/ML expertise in less than 4 weeks.",
  intro: (<><p>Transform your processes, people, products, services and conversations using actionable intelligence with our premium data analytics, AI/ML, and deep learning services.</p></>),
};

export const introColumn2Obj = {
  classes: "",
  header: "our web development expertise",
  subHeader: "Top-notch software engineering that takes mobile products for zero to one (and beyond) in less than 4 weeks",
  intro: (<><p>We deeply care about shipping products that are simple and beautiful inside out. Hence, we only pick technologies, talent, and web development practices that allows us to build high-quality software in an agile fashion</p>
    <p>Leverage technologies that allows to ship modular, reliable, and maintainable web apps quickly. We describe the technology choices as not loosing sight of  the forest while stading at the tree, i.e. delivering on your current needs in weeks, but be flexible to scale and grow on-demand to meet your dynamic business needs across all digital channels.</p></>),
};
export const threeColSliderObj = {
  classes: "",
  header: "Deliver on your mission-critical initiatives ",
  subHeader: "Premium data analytics services",
  items: [
    {
      icon: <IconDeliverPersonalized />,
      header: "Deliver Personalized Experiences",
      content: "57% of buyers expect companies to know what they want. Use AI/ML to deliver proactive and personalized experiences across all channels."
    }, {
      icon: <IconCustomerInteraction />,
      header: "Improve Every Customer Interaction",
      content: "Enrich each customer interaction across sales, service, and marketing with contextual intelligence, chatbots, and AI-powered assistants."
    }, {
      icon: <IconRevenueOpportunities />,
      header: "Create New Revenue Opportunities",
      content: "49% of consumers shop frequently, and 34% spend more money when AI is used. Increase sales by offering customers the right offers at the right time."
    }, {
      icon: <IconBuildNextGen />,
      header: "Build Next-gen Products & Services",
      content: "Launch smart, proactive and self-learning products and services that offer unique value thanks to ML, NLP and the massive amount of data."
    }, {
      icon: <IconDeliverIntelligence />,
      header: "Deliver Intelligence at Massive Scale",
      content: "Generate powerful intelligence from a large variety and volume of data using distributed systems such as Spark, Hadoop, Elasticsearch, etc."
    }, {
      icon: <IconImproveProcesses />,
      header: "Improve Processes with Automation",
      content: "Use AI, machine learning, and RPA to automate manual and repetitive processes to reduce costs and increase business outcomes."
    }
  ]
};
export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "our data analytics expertise",
  subHeader: "Explore Our Data Analytics Services",
  gridItems: [
    {
      icon: <IconDataEngineering />,
      header: "Data Engineering",
      content: "Build tailor-made data integration, analytics, and consumption platforms and solutions."
    },
    {
      icon: <IconOmnichannelPlatforms />,
      altText: "Icon Omnichanne lPlatforms",
      header: "Omnichannel Platforms",
      content: "Create channel-agnostic custom experiences based on your user’s needs, journeys, and behaviors in real-time."
    },
    {
      icon: <IconDataVisualization />,
      header: "Data Visualization Platforms",
      content: "Design and develop intuitive, scalable, and extendable data visualization platforms for graph, geo, and visual data exploration."
    },
    {
      icon: <IconPersonalizationEngines />,
      header: "Personalization Engines",
      content: "Grow your revenue and brand loyalty with personalized products and shopping experiences unique to each customer."
    },
    // {
    //   icon: <IconLanguageProcessing/>,
    //   header: "Natural Language Processing",
    //   content: "Make sense of unstructured or semi-structured data and document data."
    // },
    {
      icon: <IconIotService />,
      header: "IoT & Machine Analytics",
      content: "Build real-time and scalable automation and data-driven products with IoT devices and events data."
    },
    {
      icon: <IconVoiceAnalytics />,
      header: "Image, Text & Voice Analytics",
      content: "Uncover the hidden insights from unstructured semi-structured data using computer vision and deep learning."
    }
  ],
  getStarted: {
    header: "Let's get started",
    content: "Have a project for us? Book a free consultation.",
    link: <Link to="/contact/" className="button button-small button-black right-arrow">Contact Us</Link>
  }
};
export const columnLayoutObj = {
  classes: "",
  header: "Check out other services",
  subHeader: (<></>),
  services: [
    {
      icon: <IconMaintenance />,
      image: ImageMaintenance,
      alt: "Web App Development",
      title: "Web App Development",
      header: "Web App Development",
      content: "Launch robust, secure, and scalable web and APIs platforms in weeks.",
      link: "/services/web-development/"
    },
    {
      icon: <Icondigital />,
      image: Imagedigital,
      alt: "Product Design",
      title: "Product Design",
      header: "Product Design",
      content: "Craft state-of-the-art digital experiences for your next digital product.",
      link: "/services/digital-product/"
    }
  ]
};
export const techColumnObj = {
  classes: "",
  items: [
    {
      icon: <IconAwsColor />,
      header: "AWS",
      content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text."
    }, {
      icon: <IconGcpColor />,
      header: "GCP",
      content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text."
    }, {
      icon: <IconAzureColor />,
      header: "Azure",
      content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text."
    },
  ]
};

export const testimonialSliderObj = {
  classes: "",
  title: <>We've shipped award-winning digital products for our clients</>,
  header: "See how we lived before existing customers.",
  link: "/",
  items: [
    {
      content: "Working with the team at Rapidops has been fantastic! They are smart, efficient, and knowledgeable. They push our thinking, build high-quality software, and deliver the results. ",
      userImage: ImageUserBlank,
      userImageAlt: "Rafael Cohen",
      userImageTitle: "Rafael Cohen",
      authorName: "Rafael Cohen",
      authorOccupation: "CIO, COOK & BROADMAN GROUP",
      logo: IconCB,
      logowidth: "109",
      logoAlt: "COOK & BROADMAN GROUP",
      logoTitle: "COOK & BROADMAN GROUP"
    }, {
      content: "Rapidops is an integral part of our product development team for 5+ years. They are, by far the most skilled, committed, and hard-working team to build next-gen technology and analytics applications.",
      userImage: ImageUserBlank,
      userImageAlt: "Analytics Unicorn",
      userImageTitle: "Analytics Unicorn",
      authorName: "Analytics Unicorn",
      authorOccupation: "Director of Products",
      logo: IconTresata,
      logowidth: "110",
      logoAlt: "Tresata",
      logoTitle: "Tresata"
    }, {
      content: "Rapidops team has a unique ability to transform complex ideas into delightful data-driven software and insights. ",
      userImage: ImageUserJustin,
      userImageAlt: "Justin Cunningham",
      userImageTitle: "Justin Cunningham",
      authorName: "Justin Cunningham",
      authorOccupation: "Founder, YoDish",
      logo: IconYodish,
      logowidth: "100",
      logoAlt: "Yodish",
      logoTitle: "Yodish"
    }
  ]
};
export const pageFeatureBannerObj = {
  classes: "page-data-analytics",
  header: "FLEXPRINT",
  subHeader: "Transforming Printing with IoT",
  content: "How we helped a massive printing solutions giant transform their products and services with digital and IoT analytics?",
  link: <Link to="/work/transforming-managed-printing-with-iot-flexprint/" className="button button-white-red right-arrow">View Case Study</Link>,
  imageIsInsideRow: true,
  image: ProductDataBannerImage,
  alt: "retail digital transformation",
  title: "Retail Transformation"
};


export const webBlockQuoteObj = {
  classes: "md-blockquote",
  quote: "The easiest way to sum up my relationship with the Rapidops team is that they make me and my team look good. They can become an extension of our internal team and translate our concepts and ideas into high-functioning software.",
  author: "Chase Cabanillas",
  occupation: "CIO, Flexprint",
};

export const succesStoriesObj = {
  classesForFullColumn: "cs-flexprint",
  imageForFullColumn: ImageFlexprint,
  imageAltForFullColumn: "Salesmate CRM Dashboard",
  imageTitleForFullColumn: "crm dashboard",
  categoryForFullColumn: "B2B SERVICES",
  headerForFullColumn: "Transforming managed- printing with digital & IoT",
  subHeaderForFullColumn: (<>How we helped our client improve customer services and automate processes?</>),
  linkForFullColumn: '/work/transforming-managed-printing-with-iot-flexprint/',

  classesForhalfColumn1: "cs-ht-hlaf",
  imageForHalfColumn1: ImageHtHalf,
  imageAltForHalfColumn1: "Omnichannel Retail Experience",
  imageTitleForHalfColumn1: "omnichannel retail platform",
  categoryForHalfColumn1: "Retail",
  headerForHalfColumn1: "Harris Teeter",
  linkForForHalfColumn1: '/work/harris-teeter-online-grocery-shopping/',

  classesForhalfColumn2: "cs-salesmate-hlaf",
  imageForHalfColumn2: ImageSalesmateHalf,
  imageAltForHalfColumn2: "Salesmate CRM Dashboard",
  imageTitleForHalfColumn2: "crm dashboard",
  categoryForHalfColumn2: "CRM",
  headerForHalfColumn2: "Salesmate",
  linkForForHalfColumn2: '/work/salesmate-sales-crm/',
};


export const ctaObj = {
  title: <>Let’s discuss your analytics opportunity.</>,
  subtitle: "Unlock your digital transformation opportunities now!",
};